import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Card, FlexView, Spinner } from 'components/common'
import { TubularContext } from 'stores/TubularStore'
import { useHistory } from 'react-router-dom'
import IppnTable from 'components/home/IppnCard'
import PurchaseCard from 'components/home/PurchaseCard'
import Reservation from 'components/home/ReservationCard'
import InvoiceCard from 'components/home/InvoiceCard'
import SotTable from 'components/home/SotCard'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import SearchCard from 'components/search/SearchCard'
import SalesCard from 'components/home/SalesCard'
import { BsCardList } from 'react-icons/bs'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import { Icon } from 'components/common'

const Wrapper = styled(Card)`
  flex-direction: row;
  border-radius: 16px;
  flex-wrap: wrap;
  box-shadow: ${({ theme }) => theme.boxShadows.medium};
  background-color: #F4F4F4;
  margin-top: 4%;
  width: 1200px;
  max-width: 85%;
  min-height: 430px;
  align-content: start;
`

const SpanTitle = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 21px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray};
`

const StyledTabs = styled(Tabs)`
  width: 100%;

  .react-tabs {
    -webkit-tap-highlight-color: transparent;
  }

  .react-tabs__tab-list {
    padding: 0px;
    margin: 0px 16px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .react-tabs__tab {
    outline: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 5px;
    margin: 5px 10px 5px 0px;
    list-style: none;
    padding: 6px 12px;
    font-family: 'Noto Sans';
    font-weight: bold;
    text-transform: uppercase;
    font-size: ${({ subtab }) => subtab ? '12px' : '15px'};
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    transition: background-color 0.2s, color 0.2s, box-shadow 0.4s;
    color: #777777;

    &:hover {
      .img-close {
        opacity: 1;
      }
    }

    span {
      display: inline-block;
      min-width: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .img-close {
      background-color: white;
      border-radius: 100%;
      position: absolute;
      right: 9px;
      top: calc(50% - 9px);
      opacity: 0;
      transition: opacity 0.2s;
    }
  }

  .react-tabs__tab--selected {
    border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
    color: #303030;
  }

  .react-tabs__tab--disabled {
    opacity: 0.6;
    background-color: ${({ theme }) => theme.colors.lightGray};
    cursor: not-allowed;
  }

  .react-tabs__tab-panel {
    display: none;
  }

  .react-tabs__tab-panel--selected {
    display: block;
  }
`

const TabsTlh = ({ options, firtsActiveKey }) => {
  const { t } = useTranslation()
  const { registryLog } = useContext(UserContext)
  const history = useHistory()
  const opt = options

  const [activeKey, setActiveKey] = useState(firtsActiveKey)
  const [lastActiveKey, setLastActiveKey] = useState()
  const { isLoading, searchResult, searchSotResults,
    searchInvoiceResults, searchIppnResults,
    searchPurchaseOrderResults,
    searchReservationResults,
    searchSalesOrderResults,
    valueData, validId } = useContext(TubularContext)

  const [searchType, setSearchType] = useState({
    'invoice': false,
    'purchaseOrder': false,
    'salesOrder': false,
    'ippn': false,
    'valid': false,
    'sot': false,
    'reservation': false
  })

  const getCards = (key, status) => {
    console.log(key, status)
    setSearchType(currentState => ({
      ...currentState,
      [key]: status
    }))
  }

  const changeActiveKey = (key) => {
    setLastActiveKey(activeKey)
    setActiveKey(key)
  }

  useEffect(() => {
    if (valueData) {
      if (searchResult === 1) {
        registryLog('home', 'click', 'back')
        if (activeKey === 'ippn') {
          history.push("/ippn/" + valueData + '/valid/' + validId)
        } else {
          history.push("/" + activeKey + "/" + valueData)
        }
      } else if (searchResult > 0) {
        console.log(`entrou`)
        changeActiveKey(activeKey)
        getCards(lastActiveKey, false)
        getCards(activeKey, true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchResult, history, valueData])

  const content =
    <Wrapper flexDirection='column' alignItems='start' justifyContent='center'>
      <StyledTabs>
        <TabList>
          {opt.map((option, i) =>
            <Tab key={option.key} onClick={() => changeActiveKey(option.key)}>
              <span>{option.label.toUpperCase()}</span>
              {i.closable && <div className="img-close">
                <Icon name="cross" width="18px" height="18px" color="error" />
              </div>}
            </Tab>
          )}
        </TabList>
        {opt.map((item, index) => <TabPanel key={`tab-panel-${index}`}>{item.content}</TabPanel>)}
      </StyledTabs>

      {/* <FlexView justifyContent='center' alignItems='center'> */}
      <Card borderRadius="16px" width='95%' margin="10px 0px 10px" alignItems='start'>
        <SearchCard tab={activeKey} borderRadius="16px" alignSelf="start" styled={{ alignContent: 'start' }} backgroundColor="#fff"></SearchCard>
        {isLoading ?
          <FlexView flex="1" width="100%" height="100%" alignItems="center" fontSize="big" fontWeight="bold" color="gray" backgroundColor="transparent">
            <Spinner />
          </FlexView>
          :
          <FlexView width="95%" alignSelf="center">
            {searchType.ippn || searchType.valid || searchType.invoice || searchType.sot || searchType.purchaseOrder || searchType.salesOrder || searchType.reservation ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff" flexDirection="row" margin="5px 0px 10px">
                <BsCardList color='#777777' style={{ margin: '0px 8px 0px 0px', fontSize: '21px' }} />
                <SpanTitle>{t('tlh.home.search')}</SpanTitle>
              </FlexView>
              :
              null
            }

            {searchType.ippn || searchType.valid ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff">
                <IppnTable data={searchIppnResults} />
              </FlexView>
              :
              null
            }

            {searchType.invoice ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff">
                <InvoiceCard data={searchInvoiceResults} />
              </FlexView>
              :
              null
            }

            {searchType.sot ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff">
                <SotTable data={searchSotResults} />
              </FlexView>
              :
              null
            }

            {searchType.purchaseOrder ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff">
                <PurchaseCard data={searchPurchaseOrderResults} />
              </FlexView>
              :
              null
            }

            {searchType.salesOrder ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff">
                <SalesCard data={searchSalesOrderResults} />
              </FlexView>
              :
              null
            }

            {searchType.reservation ?
              <FlexView width="100%" borderRadius="16px" alignSelf="center" backgroundColor="#fff">
                <Reservation data={searchReservationResults} />
              </FlexView>
              :
              null
            }
          </FlexView>
        }
      </Card>
    </Wrapper>
  return content
}

export default TabsTlh
